// The single typed fetch wrapper that the entire frontend goes through.
// Empathy parity: components NEVER call fetch or import this module directly;
// they consume context provider hooks (useAuth, useSavedStrategies, …) which
// in turn call api.* methods defined in sibling files of this directory.
//
// ESLint enforces this — see eslint.config.* `no-restricted-imports` rule.

import { admin } from "./admin";
import { adminLibrary } from "./admin-library";
import { agents } from "./agents";
import { alerts } from "./alerts";
import { analytics } from "./analytics";
import { auth } from "./auth";
import { backtestRuns } from "./backtest-runs";
import { communityPosts } from "./community-posts";
import { communityProfiles } from "./community-profiles";
import { conversations } from "./conversations";
import { economicEvents } from "./economic-events";
import { investmentReplays } from "./investment-replays";
import { journalCategories } from "./journal-categories";
import { journalEntries } from "./journal-entries";
import { kolDashboard } from "./kol-dashboard";
import { library } from "./library";
import { notifications } from "./notifications";
import { optionChains } from "./option-chains";
import { personalLibrary } from "./personal-library";
import { positions } from "./positions";
import { publicKols } from "./public-kols";
import { pushSubscriptions } from "./push-subscriptions";
import { quiz } from "./quiz";
import { quotes } from "./quotes";
import { referrals } from "./referrals";
import { savedStrategies } from "./saved-strategies";
import { simulatorTabs } from "./simulator-tabs";
import { strategyUsageRecords } from "./strategy-usage-records";
import { stripe } from "./stripe";
import { superAdmin } from "./super";
import { tickerWorkspaces } from "./ticker-workspaces";
import { tickers } from "./tickers";
import { transactions } from "./transactions";
import { users } from "./users";

export {
  ApiError,
  apiErrorMessage,
  AuthError,
  request,
  resetCsrfToken,
  setAuthErrorHandler,
  updateCsrfToken,
} from "./transport";

export const api = {
  ...auth,
  ...savedStrategies,
  ...strategyUsageRecords,
  ...simulatorTabs,
  ...journalEntries,
  ...journalCategories,
  ...backtestRuns,
  ...transactions,
  ...positions,
  ...alerts,
  ...pushSubscriptions,
  ...quiz,
  ...notifications,
  ...library,
  ...kolDashboard,
  ...referrals,
  ...stripe,
  ...superAdmin,
  ...admin,
  ...adminLibrary,
  ...users,
  ...publicKols,
  ...analytics,
  ...agents,
  ...conversations,
  ...communityPosts,
  ...communityProfiles,
  ...economicEvents,
  ...investmentReplays,
  ...personalLibrary,
  ...quotes,
  ...optionChains,
  ...tickers,
  ...tickerWorkspaces,
};
